import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

export const UkCustomerDaySwiper = function (delay = 0) {
    this.init = () => {
        const swiper = new Swiper('.ukCustomerDaySwiper', {
            // Install modules
            modules: [Navigation, Pagination, Autoplay],
            wrapperClass: 'ukCustomerDaySwiper>.elementor-widget-wrap',
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            slidesPerView: 1,
            allowTouchMove: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
    };
};